export default {
  graph: state => {
    return state.graph;
  },
  graphTemplates: state => {
    return state.graphTemplates;
  },
  graphTemplateById: state => id => {
    const filtered = state.graphTemplates.filter(item => {
      return parseInt(item.id) === parseInt(id);
    });

    return filtered.length > 0 ? filtered[0] : null;
  }
};